import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import * as S from "./hero-component.style";
import { HeroProps } from "./hero-component.types";

const Hero: React.FC<HeroProps> = ({ title, subtitle, imageAlt, image }) => {
	return (
		<S.HeroContainer>
			<GatsbyImage
				image={image}
				alt={imageAlt}
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					width: "100%",
					height: "100%",
					objectFit: "cover",
					zIndex: 0,
				}}
			/>

			<S.Overlay />
			<S.HeroContent>
				<h1>{title}</h1>
				{subtitle && <h4>{subtitle}</h4>}
			</S.HeroContent>
		</S.HeroContainer>
	);
};
export default Hero;
